import { useQuery } from "react-query";
import { useHttpClient } from "../../../../shared/http/HttpClientProvider";
import { ApiNavigator } from "../../../common/types/apiNavigator";
import { Session } from "../types/session";
import { QueryOptions, QueryResult } from '../../../../shared/types/query';

export function useGetAllSessions(options?: QueryOptions<ApiNavigator<Session>>): QueryResult<ApiNavigator<Session>, any> {
    const http = useHttpClient();

    return useQuery({
        ...options,
        queryKey: ['sessions/getAll', http],
        queryFn: () => {
            return http.request<ApiNavigator<Session>>({
                method: 'get',
                url: '/?authenticatedSessionType=ManagementSession',
            }).then(result => result.data)
        },
    })
}